<template>
  <div role="status" class="rounded animate-pulse grid items-center justify-center">
    <template v-if="!circleChartsType.includes(type)">
      <div class="flex items-baseline gap-4 justify-center overflow-hidden" :style="{ scale }">
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-32"></div>
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-24"></div>
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-36"></div>
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-44"></div>
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-40"></div>
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-20"></div>
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-52"></div>
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-36"></div>
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-32"></div>
        <div class="w-7 rounded-t-lg dark:bg-gray-400 h-20"></div>
      </div>
    </template>
    <template v-else>
      <div class="rounded-full border-solid border-[20px] h-[70%] aspect-square dark:border-gray-400"></div>
    </template>
    <span class="sr-only">Loading...</span>
  </div>
</template>

<script setup lang="ts">
defineProps({
  type: {
    type: String,
    default: 'bar',
  },
  scale: {
    type: String,
    default: '1 1',
  },
});

const circleChartsType = ['donut', 'radialBar', 'pie', 'polarArea'];
</script>
